export const blockIconsTransportationCarCrashNew = (
	<span className='material-symbols-outlined'>car_crash</span>
);
